;(function () {
  'use strict';

  // ============================================
  // 3D 预览图 & 自定义价格替换（含购物车总价 + Checkout 拦截）
  // ============================================
  // 数据来源（服务端 Liquid 渲染到 DOM 属性）：
  //   data-variant-id        <- item.variant.id
  //   data-properties        <- 所有非 '_' 开头的 properties JSON 数组
  //   data-bundle-image-url  <- item.properties['_bundle_image_url']
  //   data-bundle-unit-price <- item.properties['Total Unit Price']
  //   data-quantity          <- item.quantity
  // ============================================

  // 0. HTML 实体解码（修复 &#39; 等乱码）
  // ----------------------------------------
  function decodeHtmlEntities(str) {
    if (!str || typeof str !== 'string') return str;
    return str
        .replace(/&#39;/g, "'")
        .replace(/&#x27;/g, "'")
        .replace(/&apos;/g, "'")
        .replace(/&#34;/g, '"')
        .replace(/&#x22;/g, '"')
        .replace(/&quot;/g, '"')
        .replace(/&amp;/g, '&')
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>')
        .replace(/&nbsp;/g, ' ');
  }

  // ----------------------------------------
  // 1. 单个商品图片 & 单价替换
  // ----------------------------------------
  function applyBundleOverrides(cartItem) {
    var bundleImageUrl  = cartItem.dataset.bundleImageUrl;
    var bundleUnitPrice = cartItem.dataset.bundleUnitPrice;

    // 图片替换
    if (bundleImageUrl) {
      var img = cartItem.querySelector('.cart-item--image-wrapper img');
      if (img) {
        var tempImg = new Image();
        tempImg.onload = function () {
          if (cartItem.dataset.bundleImageUrl !== bundleImageUrl) return;
          img.src = bundleImageUrl;
          img.removeAttribute('loading');
          img.removeAttribute('data-src');
          img.removeAttribute('srcset');
          img.removeAttribute('data-widths');
          img.removeAttribute('data-sizes');
          img.classList.remove('lazyload', 'lazyloaded');
          var picture = img.closest('picture');
          if (picture) {
            picture.querySelectorAll('source').forEach(function (source) {
              source.removeAttribute('srcset');
              source.removeAttribute('data-srcset');
            });
          }
        };
        tempImg.onerror = function () {
          console.warn('[bundle-cart] 预览图加载失败，保持原图');
        };
        tempImg.src = bundleImageUrl;
      }
    }

    // 单价替换（单价 x 数量 = 行总价）
    if (bundleUnitPrice!=="") {
      var quantity   = parseInt(cartItem.dataset.quantity, 10) || 1;
      var unitValue  = parseDollarAmount(bundleUnitPrice);
      var lineTotal  = unitValue * quantity;
      var lineTotalStr = '$' + lineTotal.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });

      var priceItem = cartItem.querySelector('.bcpo-cart-item-line-price');
      if (priceItem) {
        priceItem.textContent = lineTotalStr;
      }
      var oldPriceItem = cartItem.querySelector('.cart-item--content-price');
      if (oldPriceItem) {
        oldPriceItem.style.display = 'none';
      }
      var badge = cartItem.querySelector('.cart-item--sku');
      if (badge) {
        badge.style.display = 'none';
      }
    }
  }

  function applyAllBundleOverrides() {
    var items = document.querySelectorAll('li[data-bundle-image-url], li[data-bundle-unit-price]');
    for (var i = 0; i < items.length; i++) {
      applyBundleOverrides(items[i]);
    }
  }

  // ----------------------------------------
  // 2. 购物车总价替换
  // ----------------------------------------
  function parseDollarAmount(str) {
    if (!str) return 0;
    var cleaned = str.replace(/[^0-9.]/g, '');
    return parseFloat(cleaned) || 0;
  }

  function updateCartTotalElements(total) {
    var formatted = formatCurrency(total);
    var els1 = document.querySelectorAll('.cart-drawer-subtotal__price');
    for (var j = 0; j < els1.length; j++) {
      els1[j].textContent = formatted;
    }
    var els2 = document.querySelectorAll('.cart-title-total .money');
    for (var k = 0; k < els2.length; k++) {
      els2[k].textContent = formatted;
    }
  }

  function applyCartTotalFromItems(items) {
    if (!items || !items.length) return;

    var total = 0;
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      var bundleUnitPrice = item.properties && item.properties._total_price;
      var quantity = parseInt(item.quantity, 10) || 1;

      if (bundleUnitPrice) {
        total += parseDollarAmount(String(bundleUnitPrice)) * quantity;
      } else {
        total += (parseInt(item.final_line_price, 10) || 0) / 100;
      }
    }

    updateCartTotalElements(total);
  }

  function applyCartItemsFromResponse(items) {
    if (!items || !items.length) return;

    var itemsByKey = Object.create(null);
    for (var i = 0; i < items.length; i++) {
      itemsByKey[items[i].key] = items[i];
    }

    var rows = document.querySelectorAll('li[data-cartitem-key]');
    for (var j = 0; j < rows.length; j++) {
      var row = rows[j];
      var item = itemsByKey[row.dataset.cartitemKey];
      if (!item) continue;

      var properties = item.properties || {};
      var bundleImageUrl = properties._bundle_image_url || '';
      var bundleUnitPrice = properties._total_price || '';

      row.dataset.bundleImageUrl = bundleImageUrl;
      row.dataset.bundleUnitPrice = bundleUnitPrice;
      row.dataset.quantity = item.quantity;
      row.dataset.linePrice = item.final_line_price;

      applyBundleOverrides(row);
    }
  }

  function applyCartTotal() {
    var allCartItems = document.querySelectorAll('li[data-cartitem]');
    if (!allCartItems.length) return;
    var total = 0;
    for (var i = 0; i < allCartItems.length; i++) {
      var item = allCartItems[i];
      var bundleUnitPrice = item.dataset.bundleUnitPrice;
      if (bundleUnitPrice) {
        if (!item.dataset.quantity) return;
        var quantity = parseInt(item.dataset.quantity, 10);
        if (!quantity) return;
        total += parseDollarAmount(bundleUnitPrice) * quantity;
      } else {
        if (!item.dataset.linePrice) return;
        var linePriceCents = parseInt(item.dataset.linePrice, 10);
        if (isNaN(linePriceCents)) return;
        total += linePriceCents / 100;
      }
    }
    updateCartTotalElements(total);
  }

  function formatCurrency(amount) {
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    var formatted = amount.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
    // return '$' + formatted + ' ' + currency;
    return '$' + formatted
  }

  function applyAll() {
    applyAllBundleOverrides();
    applyCartTotal();
  }

  // ----------------------------------------
  // 3. 初始化 & 事件绑定
  // ----------------------------------------
  var cartUpdateTimer = null;

  function setCartLoading(loading) {
    var cart = document.querySelector('[data-cart-item-list]');
    if (!cart) return;

    cart.classList.toggle('is-loading', loading);

    cart.querySelectorAll('[data-cartitem-quantity], [data-cartitem-remove]')
        .forEach(function (element) {
          if ('disabled' in element) element.disabled = loading;
        });
  }
  function init() {
    setTimeout(applyAll, 400);
    document.addEventListener('change', function (event) {
      if (event.target.matches('[data-cartitem-quantity]')) {
        setCartLoading(true);
      }
    }, true);

    document.addEventListener('click', function (event) {
      if (event.target.closest('[data-cartitem-remove]')) {
        setCartLoading(true);
      }
    }, true);

    document.addEventListener('on:cart:change', function () {
      setTimeout(applyAll, 300);
    });
    document.addEventListener('on:cart:after-merge', function () {
      setTimeout(applyAll, 300);
    });
    window.addEventListener('cartcount:update', function (event) {
      var items = event.detail && event.detail.items;
      clearTimeout(cartUpdateTimer);
      cartUpdateTimer = setTimeout(function () {
        applyCartTotalFromItems(items);
        applyCartItemsFromResponse(items);
        setCartLoading(false);
      }, 0);
      setTimeout(applyAll, 300);
      setCartLoading(false);
    });

    var observer = new MutationObserver(function (mutations) {
      var hasNewCartItem = false;
      for (var mi = 0; mi < mutations.length; mi++) {
        var mutation = mutations[mi];
        for (var ni = 0; ni < mutation.addedNodes.length; ni++) {
          var node = mutation.addedNodes[ni];
          if (node.nodeType !== 1) continue;
          if (
            node.tagName === 'CART-ITEM' ||
            (node.classList && node.classList.contains('cart-item')) ||
            (node.querySelector && node.querySelector('cart-item, .cart-item'))
          ) {
            hasNewCartItem = true;
            break;
          }
        }
        if (hasNewCartItem) break;
      }
      if (hasNewCartItem) {
        setTimeout(applyAllBundleOverrides, 100);
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // ============================================
  // 4. Checkout 按钮拦截：创建草稿订单
  // ============================================

  // --- 工具函数 ---
  function createShopifyDraftOrder(orderData) {
    var url = 'https://stoneandsink.vercel.app/api/create-order';
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ orderData: orderData })
    }).then(function (r) { return r.json(); });
  }

  async function collectLineItems() {
    const response = await fetch("/cart.js");
    const cart = await response.json();
    const currency = cart.currency;

    if (cart.items.length === 0) {
      window.location.reload();
      return []; // 无商品时返回空数组
    }

    const result = [];
    let has3DOrder = false;
    for (const cartItem of cart.items) {
      const variantId = cartItem.variant_id;
      const quantity = parseInt(cartItem.quantity, 10) || 1;
      const bundleUnitPrice = cartItem.properties?._total_price;

      let priceOverride = null;
      if (bundleUnitPrice) {
        has3DOrder = true;
        priceOverride = {
          amount: parseFloat(bundleUnitPrice).toFixed(2),
          currencyCode: currency,
        };
      }

      // ✅ 正确遍历 properties 对象
      const customAttributes = [];
      const props = cartItem.properties;
      if (props && typeof props === "object") {
        for (const [key, value] of Object.entries(props)) {
          // 跳过内部使用的 _total_price 等私有字段（可选）
          if (key === "_total_price" || key === "_bundle_image_url") continue;
          customAttributes.push({
            key: decodeHtmlEntities(String(key)),
            value: decodeHtmlEntities(String(value || "")),
          });
        }
      }

      result.push({
        variantId: `gid://shopify/ProductVariant/${variantId}`,
        quantity: quantity,
        priceOverride: priceOverride,
        customAttributes: customAttributes,
      });
    }
    if (has3DOrder) {
      return result;
    }else {
      nativeCheckout();
      return false;
    }
  }

  function getCartNote() {
    var ta = document.querySelector('cart-note textarea, .cart-note__textarea, .cart-order-notes__cart-note textarea');
    if (ta && ta.value.trim()) return ta.value.trim();
    return '';
  }

  function shouldSkipBundleCheckout(btn) {
    return btn && btn.dataset.bundleCheckoutSkip === 'true';
  }

  function restoreBtn(btn, text) {
    if (!btn) return;
    btn.disabled = false;
    var bTextEl = btn.querySelector('[data-button-text]');
    if (bTextEl) {
      bTextEl.textContent = text;
    } else {
      btn.textContent = text;
    }
  }

  function nativeCheckout(form, btn) {
    var f = form;
    if (!f && btn) {
      var fid = btn.getAttribute('form');
      if (fid) f = document.getElementById(fid);
    }
    if (f) {
      var wasDisabled = btn ? btn.disabled : false;
      if (btn) btn.disabled = false;
      f.submit();
      if (btn) btn.disabled = wasDisabled;
    } else {
      window.location.href = '/checkout';
    }
  }

  // --- 核心拦截逻辑 ---
  async function doBundleCheckout(e, formEl, clickedBtn) {
    var btn = clickedBtn || null;
    if (!btn && e && e.target) {
      btn = e.target.closest && e.target.closest('button[name="checkout"], button[data-cart-checkout-button], a[href*="/checkout"]');
    }
    if (!btn || shouldSkipBundleCheckout(btn)) return;

    if (e && typeof e.preventDefault === 'function') {
      e.preventDefault();
    }
    if (e && typeof e.stopImmediatePropagation === 'function') {
      e.stopImmediatePropagation();
    }

    var originalText = (btn.textContent || 'Checkout').trim();
    btn.disabled = true;
    var btnTextEl = btn.querySelector('[data-button-text]');
    if (btnTextEl) {
      btnTextEl.textContent = 'Processing...';
    } else {
      btn.textContent = 'Processing...';
    }

    const lineItems = await collectLineItems();
    if (lineItems === false) return;
    var orderData = {lineItems: lineItems, note: getCartNote(),"acceptAutomaticDiscounts": true, "allowDiscountCodesInCheckout": true };

    createShopifyDraftOrder(orderData)
      .then(function (result) {
        if (result && result.invoiceUrl) {
          // fetch('/cart/clear.js', { method: 'POST' })
          //     .then(function () {
          //       window.location.href = result.invoiceUrl;
          //     })
          //     .catch(function () {
          //       // 清空失败也跳转，不阻塞
          //       window.location.href = result.invoiceUrl;
          //     });
          window.location.href = result.invoiceUrl;
        } else if (result && result.id) {
          var fallbackUrl = '/admin/draft_orders/' + result.id;
          if (confirm('Draft order created (ID: ' + result.id + '), go to admin?')) {
            window.location.href = fallbackUrl;
          } else {
            restoreBtn(btn, originalText);
          }
        } else {
          console.warn('[bundle-cart] 订单返回异常:', result);
          alert('Order creation failed. Please try again later.');
          restoreBtn(btn, originalText);
          // nativeCheckout(formEl, btn);
        }
      })
      .catch(function (err) {
        console.error('[bundle-cart] 创建订单失败:', err);
        alert('Error creating order. Please refresh and try again.');
        restoreBtn(btn, originalText);
        // nativeCheckout(formEl, btn);
      });
  }

  // --- 等待 form 出现在 DOM ---
  function waitForFormAndIntercept(formId, callback) {
    if (!formId) { callback(null); return; }
    var formEl = document.getElementById(formId);
    if (formEl) { callback(formEl); return; }

    var timeoutId = setTimeout(function () {
      obs.disconnect();
      console.warn('[bundle-cart] waitForForm timeout:', formId);
      callback(null);
    }, 10000);

    var obs = new MutationObserver(function () {
      var form = document.getElementById(formId);
      if (form) {
        clearTimeout(timeoutId);
        obs.disconnect();
        callback(form);
      }
    });
    obs.observe(document.body, { childList: true, subtree: true });
  }

  // --- 事件委托（capture 阶段）---
  function attachCheckoutDelegation() {
    // click 委托
    document.body.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('button[name="checkout"], button[data-cart-checkout-button], a[href*="/checkout"]');
      if (!btn) return;
      if (shouldSkipBundleCheckout(btn)) return;

      var formEl = (btn.form) || (btn.getAttribute('form') ? document.getElementById(btn.getAttribute('form')) : null);

      if (formEl) {
        console.log('[bundle-cart] click intercept (form exists):', formEl.id || 'unknown');
        doBundleCheckout(e, formEl, btn);
      } else {
        e.preventDefault();
        e.stopImmediatePropagation();
        console.log('[bundle-cart] click intercept (form not yet), waiting...');
        waitForFormAndIntercept(btn.getAttribute('form'), function (resolvedForm) {
          if (!resolvedForm) {
            console.warn('[bundle-cart] form never appeared, native checkout');
            // window.location.href = '/checkout';
            return;
          }
          console.log('[bundle-cart] form appeared, creating draft order');
          doBundleCheckout(
            { preventDefault: function(){}, stopImmediatePropagation: function(){} },
            resolvedForm,
            btn
          );
        });
      }
    }, true);

    // submit 委托（兜底）
    document.body.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form) return;
      var formId     = form.id || '';
      var formAction = form.action || '';
      if (formId === 'CartDrawerForm' ||
          formAction.indexOf('/cart') !== -1 ||
          formAction.indexOf('/checkout') !== -1) {
        var hasCheckoutBtn = form.querySelector('button[name="checkout"], button[data-cart-checkout-button]');
        if (hasCheckoutBtn && !shouldSkipBundleCheckout(hasCheckoutBtn)) {
          console.log('[bundle-cart] submit intercept:', formId);
          doBundleCheckout(e, form, hasCheckoutBtn);
        }
      }
    }, true);
  }

  // --- 强力兜底：重写 HTMLFormElement.prototype.submit ---
  (function overrideFormSubmit() {
    var originalSubmit = HTMLFormElement.prototype.submit;
    HTMLFormElement.prototype.submit = function () {
      var form = this;
      var formId = form.id || '';
      if (formId === 'CartDrawerForm' ||
          (form.action && (form.action.indexOf('/cart') !== -1 || form.action.indexOf('/checkout') !== -1))) {
        var btns = form.querySelectorAll('button[name="checkout"], button[data-cart-checkout-button]');
        if (btns.length > 0) {
          var btn = btns[0];
          if (btn.dataset.bundleCheckoutSkip !== 'true') {
            console.log('[bundle-cart] submit() overridden for:', formId);
            var fakeEvent = { preventDefault: function(){}, stopImmediatePropagation: function(){} };
            doBundleCheckout(fakeEvent, form, btn);
            return;
          }
        }
      }
      originalSubmit.call(form);
    };
    console.log('[bundle-cart] HTMLFormElement.prototype.submit overridden');
  })();

  // =====================
  // 启动
  // =====================
  attachCheckoutDelegation();
  // 所有下单拦截器已安装，通知 3D 商品页可以解除购买门槛。
  window.bundleCartReady = true;
  window.dispatchEvent(new Event('bundle-cart-ready'));
  console.info('[下单脚本] 初始化完成');

})();
